export const BOOK_READ = 'BOOK_READ';
export const CATEGORIES_READ = 'CATEGORIES_READ';
export const CATEGORIES_WRITE = 'CATEGORIES_WRITE';
export const DOCUMENTS_READ = 'DOCUMENTS_READ';
export const DOCUMENTS_WRITE = 'DOCUMENTS_WRITE';
export const DOCUMENTS_WRITE_ALL = 'DOCUMENTS_WRITE_ALL';
export const PROFILES_READ = 'PROFILES_READ';
export const PROFILES_WRITE = 'PROFILES_WRITE';
export const USERS_READ = 'USERS_READ';
export const USERS_WRITE = 'USERS_WRITE';
export const NEWS_READ = 'NEWS_READ';
export const NEWS_WRITE = 'NEWS_WRITE';
export const FUNCTION_GROUPS_READ = 'FUNCTION_GROUPS_READ';
export const FUNCTION_GROUPS_WRITE = 'FUNCTION_GROUPS_WRITE';
export const USER_GROUPS_READ = 'USER_GROUPS_READ';
export const USER_GROUPS_WRITE = 'USER_GROUPS_WRITE';
export const ROADMAP_READ = 'ROADMAP_READ';
export const ROADMAP_WRITE = 'ROADMAP_WRITE';
export const LINKS_READ = 'LINKS_READ';
export const LINKS_WRITE = 'LINKS_WRITE';
export const REGIONS_AGENCIES_READ = 'REGIONS_AGENCIES_READ';
export const REGIONS_AGENCIES_WRITE = 'REGIONS_AGENCIES_WRITE';

export const resources = [
  {
    label: 'Book',
    roles: [
      { role: BOOK_READ, label: 'Voir' },
    ],
  },
  {
    label: 'Back-Office Sujets',
    roles: [
      { role: DOCUMENTS_READ, label: 'Voir' },
      { role: DOCUMENTS_WRITE, label: 'Modifier mes sujets' },
      { role: DOCUMENTS_WRITE_ALL, label: 'Modifier tous les sujets' },
    ],
  },
  {
    label: 'Back-Office Rubriques',
    roles: [
      { role: CATEGORIES_READ, label: 'Voir' },
      { role: CATEGORIES_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Utilisateurs',
    roles: [
      { role: USERS_READ, label: 'Voir' },
      { role: USERS_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Profils',
    roles: [
      { role: PROFILES_READ, label: 'Voir' },
      { role: PROFILES_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Fil d\'informations',
    roles: [
      { role: NEWS_READ, label: 'Voir' },
      { role: NEWS_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Groupes de fonctions',
    roles: [
      { role: FUNCTION_GROUPS_READ, label: 'Voir' },
      { role: FUNCTION_GROUPS_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Groupes d\'utilisateurs',
    roles: [
      { role: USER_GROUPS_READ, label: 'Voir' },
      { role: USER_GROUPS_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Feuille de route',
    roles: [
      { role: ROADMAP_READ, label: 'Voir' },
      { role: ROADMAP_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Back-Office Régions et ZDV',
    roles: [
      { role: REGIONS_AGENCIES_READ, label: 'Voir' },
      { role: REGIONS_AGENCIES_WRITE, label: 'Modifier' },
    ],
  },
  {
    label: 'Liens utiles',
    roles: [
      { role: LINKS_READ, label: 'Voir dans le back-office' },
      { role: LINKS_WRITE, label: 'Modifier' },
    ],
  },
];



// WEBPACK FOOTER //
// ./shared/src/security/userRoles.js